import React from "react";
import Util from "../../Util";
import style from "./Style.module.css";
import { withAlert } from "react-alert";
import { withRouter } from "react-router-dom";
import { Container } from "react-grid-system";
import { DatePicker, Modal, Switch } from "antd";
import { Button } from "antd";
import moment from "moment";
import "./staffEditSheet.css";
class EditSheet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      redirect: false,
      confirmLiveEnd: false,
      data: {
        sheet: {
          name: "",
          classInfo: "",
          detail: "",
          price: "",
          examNum: 0,
          id: "",
          semester: 1,
          year: 2019,
          category: 0,
          visible: true,
          highlighted: false,
          pin: false,
          onlineTutor: {
            isLiveSteamEnded: undefined,
            url: undefined,
            liveReplayUrl: undefined,
            startDate: undefined,
          },
        },
      },
      sCode: "",
      sName: "",
      cover: false,
      example: false,
      exampleRawUrls: [],
      sampleVersion: Date.now(),
      blobUrls: [],
      loadingSamples: false,
      pdf: false,
      updCover: false,
      updSample: false,
      updPdf: false,
      saving: false,
      showSplit: false,
      splitname: "",
      splitStep: 0,
      pages: [{ start: 1, end: 3, cover: false }],
      newpages: [],
    };
  }

  componentWillUnmount() {
    this.state.blobUrls.forEach((u) => URL.revokeObjectURL(u));
  }

  async componentDidMount() {
    var id = window.location.search.substring(1);
    var data = await Util.sendPost("/api/moresheetStaff/getSheet", { id });
    if (!data.success) {
      await alert(data.msg[0]);
      return this.props.history.push("/staff/sheetInfo");
    }
    var name = data.data.sheet.name;
    await this.setState({
      sCode: name.substr(0, name.indexOf(" ")),
      sName: name.substr(name.indexOf(" ") + 1),
    });
    await this.setState({ data: data.data });
    await this.reloadCover(id);
    await this.loadSamples();
    await this.loadPdf();
  }

  render() {
    return (
      <React.Fragment>
        <div className={style.sheetPage}>
          <Container>
            <div className={style.container}>
              <div className={style.blankTop} />
              <div className={style.header}>Staff แก้ไขชีท</div>
              <hr />
              {this.state.data.sheet.visible ? (
                <React.Fragment>
                  <div className={style.statusGreen}>
                    ชีทเปิดให้ซื้อได้ในขณะนี้
                  </div>
                  <div className={style.hideButt} onClick={this.hideSheet}>
                    ซ่อนชีท
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className={style.statusRed}>ชีทถูกซ่อน</div>
                  <div className={style.showButt} onClick={this.showSheet}>
                    เปิดชีทให้ซื้อ
                  </div>
                </React.Fragment>
              )}
              {this.state.data.sheet.highlighted ? (
                <React.Fragment>
                  <div className={style.statusGreen}>ชีทถูกแนะนำ</div>
                  <div
                    className={style.hideButt}
                    onClick={this.stopHighlightSheet}
                  >
                    เอาชีทออกจากการแนะนำ
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className={style.statusRed}>ชีทไม่ถูกแนะนำ</div>
                  <div className={style.showButt} onClick={this.highlightSheet}>
                    ตั้งเป็นชีทแนะนำ
                  </div>
                </React.Fragment>
              )}
              <div className={style.label}>ชนิดของชีทสรุป</div>
              <select
                className={style["textField"]}
                value={this.state.data.sheet.category}
                onChange={(event) => {
                  this.setField("category", event.currentTarget.value);
                }}
              >
                {this.genCatOptions()}
              </select>
              <div className={style.label}>ภาค / ปีการศึกษา</div>
              <div className="flexGap">
                <select
                  className={style["textFieldHalf"]}
                  value={this.state.data.sheet.semester}
                  onChange={(event) => {
                    this.setField("semester", event.currentTarget.value);
                  }}
                >
                  {this.genTermOptions()}
                </select>
                <select
                  className={style["textFieldHalf"]}
                  value={this.state.data.sheet.year}
                  onChange={(event) => {
                    this.setField("year", event.currentTarget.value);
                  }}
                >
                  {this.genYearOptions()}
                </select>
              </div>

              <div className={style.subjectCodeGroup}>
                <div>
                  <div className={style.label}>ปักหมุด</div>
                  <div className={style.explainLabel}>
                    แสดงชีทนี้อยู่ด้านบนสุดของรายการเสมอ <br />
                    เพื่อให้สรุปรายนี้เข้าถึงได้ง่าย
                    ไม่ต้องเลื่อนหาในรายการชีตจำนวนมาก
                  </div>
                </div>
                <Switch
                  checkedChildren="เปิด"
                  unCheckedChildren="ปิด"
                  onClick={() => {
                    this.setField("pin", !this.state.data.sheet.pin);
                  }}
                  checked={this.state.data.sheet.pin}
                />
              </div>

              <div className={style.subjectCodeGroup}>
                <div>
                  <div className={style.label}>รหัสวิชา</div>
                  <div className={style.explainLabel}>
                    ตัวพิมพ์ใหญ่เท่านั้น และห้ามมีเว้นวรรค เช่น 2110611 หรือ
                    TU101
                  </div>
                </div>
              </div>

              <input
                type="text"
                className={style["textField"]}
                value={this.state.sCode}
                onChange={(event) => {
                  this.setFieldCode(event.currentTarget.value);
                }}
              />
              <div className={style.label}>ชื่อวิชา</div>
              <input
                type="text"
                className={style["textField"]}
                value={this.state.sName}
                onChange={(event) => {
                  this.setFieldName(event.currentTarget.value);
                }}
              />
              <div className={style.label}>รายละเอียดคลาส / ตอนเรียน</div>
              <textarea
                className={style["textArea"]}
                value={this.state.data.sheet.classInfo}
                onChange={(event) => {
                  this.setField("classInfo", event.currentTarget.value);
                }}
              />
              <div className={style.label}>รายละเอียดเนื้อหา</div>
              <textarea
                className={style["textArea"]}
                value={this.state.data.sheet.detail}
                onChange={(event) => {
                  this.setField("detail", event.currentTarget.value);
                }}
              />
              <div className={style.label}>ราคา</div>
              <input
                type="text"
                className={style["textField"]}
                value={this.state.data.sheet.price}
                onChange={(event) => {
                  this.setField("price", event.currentTarget.value);
                }}
              />
              <div className={style.label}>
                ภาพหน้าปก (หากอัพผิดให้กดเซฟ มันจะสร้างรูปใหม่
                ดังนั้นถ้าจะแก้ทั้งข้อมูลทั้งปก เซฟปกเก่าไว้ก่อน)
              </div>
              <div className={style.explainLabel}></div>
              {this.state.updCover ? (
                <div className={style.uploadInfo}>กำลังอัพโหลด</div>
              ) : (
                <React.Fragment>
                  <input
                    type="file"
                    className={style["fileField"]}
                    onChange={(event) => {
                      this.uploadCover(event.currentTarget.files[0]);
                    }}
                  />
                  <div className={style.explainLabel}>
                    รูปที่ใช้อยู่(สร้างอัตโนมัติเมื่อมีการเซฟ) :
                  </div>
                  {this.state.cover ? (
                    <a
                      href={this.state.cover}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        alt=""
                        src={this.state.cover}
                        className={style["coverImage"]}
                      />
                    </a>
                  ) : (
                    <div className={style.notFound}>ไม่พบไฟล์ที่เคยอัพโหลด</div>
                  )}
                </React.Fragment>
              )}
              <div className={style.label}>
                รูปตัวอย่างชีท (ถ้าอัพแล้วของเก่าจะหาย ห้ามกดปุ่มหากไม่จำเป็น)
              </div>
              <div className={style.explainLabel}>
                ตั้งแต่ 1-10 รูป แต่ละรูปขนาดไม่เกิน 1MB
                (ให้นำรูปมาไว้ในโฟลเดอร์เดียวกันแล้วเลือกทีเดียว)
              </div>
              {this.state.updSample ? (
                <div className={style.uploadInfo}>{this.state.updSample}</div>
              ) : (
                <React.Fragment>
                  <input
                    type="file"
                    className={style["fileField"]}
                    onChange={(event) => {
                      this.uploadSample(event.currentTarget.files);
                    }}
                    multiple
                  />
                  <div className={style.explainLabel}>
                    รูปตัวอย่างที่ใช้อยู่ทั้งหมด :
                  </div>
                  {this.state.loadingSamples ? (
                    <div className={style.uploadInfo}>กำลังโหลดรูปตัวอย่างใหม่...</div>
                  ) : this.state.data.sheet.examNum > 0 ? (
                    <div key={this.state.sampleVersion}>
                      {this.renderSamples(this.state.example, this.state.exampleRawUrls)}
                    </div>
                  ) : (
                    <div className={style.notFound}>ไม่พบไฟล์ที่เคยอัพโหลด</div>
                  )}
                </React.Fragment>
              )}
              {this.state.pdf && (
                <React.Fragment>
                  <div className={style.label}>
                    ไฟล์ชีท **ที่ใส่หน้าปกมาแล้ว หาวิธีใส่ได้ในหน้าก่อนหน้า**
                    (ถ้าอัพแล้วของเก่าจะหาย ห้ามกดปุ่มหากไม่จำเป็น)
                  </div>
                  <div className={style.explainLabel}>
                    ไฟล์ pdf ขนาดไม่เกิน 150MB
                  </div>
                  {this.state.updPdf ? (
                    <div className={style.uploadInfo}>{this.state.updPdf}</div>
                  ) : (
                    <React.Fragment>
                      <input
                        type="file"
                        className={style["fileField"]}
                        onChange={(event) => {
                          this.uploadPdf(event.currentTarget.files[0]);
                        }}
                      />
                      <div className={style.explainLabel}>
                        ไฟล์ชีทปัจจุบัน :
                      </div>
                      {this.state.pdf ? (
                        <a
                          href={this.state.pdf}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={style.pdfLink}
                        >
                          คลิกเพื่อดูไฟล์
                        </a>
                      ) : (
                        <div className={style.notFound}>
                          ไม่พบไฟล์ที่เคยอัพโหลด
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
              <hr />
              <div className={style.flexBetween}>
                <div className={style.tutorialTitle} style={{ margin: 0 }}>
                  ติวออนไลน์
                </div>
                <Button
                  type="primary"
                  danger
                  shape="round"
                  className={style.endedLiveBtn}
                  disabled={
                    this.state.data?.sheet?.onlineTutor?.isLiveSteamEnded
                  }
                  onClick={() => {
                    this.setState({ confirmLiveEnd: true });
                  }}
                >
                  สิ้นสุดการไลฟ์
                </Button>
              </div>
              {this.state.data?.sheet?.onlineTutor?.isLiveSteamEnded ? (
                <>
                  <div className={style.label}>ลิงค์ดูย้อนหลัง</div>
                  <input
                    type="text"
                    className={style["textField"]}
                    value={this.state.data?.sheet?.onlineTutor?.liveReplayUrl}
                    placeholder="https://www.example.com"
                    onChange={(event) => {
                      this.setField(
                        "onlineTutor.liveReplayUrl",
                        event.currentTarget.value
                      );
                    }}
                  />
                </>
              ) : null}

              <div className={style.label}>ลิงค์ไลฟ์</div>
              <input
                type="text"
                className={style["textField"]}
                value={this.state.data?.sheet?.onlineTutor?.url}
                placeholder="https://www.example.com"
                disabled={this.state.data?.sheet?.onlineTutor?.isLiveSteamEnded}
                onChange={(event) => {
                  this.setField("onlineTutor.url", event.currentTarget.value);
                }}
              />
              <div className={style.label}>วัน-เวลาที่ไลฟ์</div>
              <DatePicker
                className={style.datePickerStyle}
                showTime={{ format: "HH:mm" }}
                format="DD/MM/YYYY HH:mm"
                value={
                  this.state.data?.sheet?.onlineTutor?.startDate
                    ? moment(
                        this.state.data?.sheet?.onlineTutor?.startDate * 1000
                      )
                    : null
                }
                onChange={(moment) => {
                  if (!moment) return;
                  this.setField("onlineTutor.startDate", moment?.unix());
                }}
              />
              <hr />
              <div className={style.buttContainer}>
                {this.state.saving ? (
                  <div className={style.smallLoader} />
                ) : (
                  <React.Fragment>
                    <div
                      onClick={() => this.saveDraft()}
                      className={style.saveButton}
                    >
                      บันทึกการเปลี่ยนแปลง
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
          </Container>
        </div>

        <Modal
          open={this.state.confirmLiveEnd}
          onCancel={() => {
            this.setState({ confirmLiveEnd: false });
          }}
          footer={null}
        >
          <h2 className={style.modalConfirm}>ยืนยันการสิ้นสุดการไลฟ์</h2>
          <div className={style.modalAction}>
            <Button
              danger
              shape="round"
              size="large"
              style={{ border: "1px solid #F00" }}
              onClick={() => {
                this.setState({ confirmLiveEnd: false });
              }}
            >
              ยกเลิก
            </Button>
            <Button
              type="primary"
              danger
              shape="round"
              size="large"
              style={{ backgroundColor: "#F00" }}
              onClick={() => {
                this.setState({ confirmLiveEnd: false });
                this.setField("onlineTutor.isLiveSteamEnded", true);
              }}
            >
              ยืนยัน
            </Button>
          </div>
        </Modal>
      </React.Fragment>
    );
  }

  genUniOptions = () => {
    if (this.state.data.store.length === 0) return [{ value: "0", name: "" }];
    return this.state.data.store.map(({ name, short, code }) => ({
      value: code.toString(),
      name: name[0],
    }));
  };

  setUni = async (value) => {
    var dat = this.state.data;
    dat.sheet.store = parseInt(value.value);
    this.setState({ data: dat });
  };

  genCatOptions = () => {
    const ops = [
      { label: "ไฟนอล", value: 2 },
      { label: "มิดเทอม", value: 1 },
      { label: "อื่น ๆ", value: 0 },
    ];
    return ops.map(({ label, value }) => (
      <option label={label} value={value} key={value}>
        {label}
      </option>
    ));
  };

  genTermOptions = () => {
    const ops = [
      { label: "1", value: 1 },
      { label: "2", value: 2 },
      { label: "3", value: 3 },
    ];
    return ops.map(({ label, value }) => (
      <option label={label} value={value} key={value}>
        {label}
      </option>
    ));
  };

  genYearOptions = () => {
    var ops = [];
    var curr = new Date().getFullYear();
    for (var i = 0; i < 10; i++) ops.push(curr - i);
    return ops.map((y) => (
      <option label={y} value={y} key={y}>
        {y}
      </option>
    ));
  };

  setField = async (field, value) => {
    if (field.split(".").length === 1) {
      var dat = this.state.data;
      dat.sheet[field] = value;
      this.setState({ data: dat });
    } else {
      const keys = field.split(".");
      let target = this.state.data.sheet;
      while (keys.length > 1) {
        const key = keys.shift();
        if (target[key]) {
          console.log(target, target[key]);

          target = target[key];
          target[keys[0]] = value.trim() === "" ? undefined : value;
        } else {
          target = Object.assign(target, { [key]: { [keys[0]]: value } });
        }
      }
      this.setState({ data: this.state.data });
    }
  };

  setFieldCode = async (value) => {
    this.setState({ sCode: value.replace(/\s/g, "").toUpperCase() });
  };

  setFieldName = async (value) => {
    this.setState({ sName: value.trim() });
  };

  reloadCover = async (id) => {
    try {
      const cover = await Util.checkCover(id);
      await this.setState({ cover: cover });
    } catch (err) {}
  };

  // retry fetch จนกว่ารูปจะพร้อมบน server หรือหมด maxRetries
  fetchSampleWithRetry = async (url, maxRetries = 8, intervalMs = 1500) => {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const res = await fetch(url, { cache: "reload", mode: "cors" });
        if (res.ok) {
          const blob = await res.blob();
          return URL.createObjectURL(blob);
        }
        console.warn(`[loadSamples] attempt ${attempt}/${maxRetries} not ok (${res.status}):`, url);
      } catch (e) {
        console.warn(`[loadSamples] attempt ${attempt}/${maxRetries} error (CORS?):`, url, e);
      }
      if (attempt < maxRetries) {
        await new Promise((resolve) => setTimeout(resolve, intervalMs));
      }
    }
    // fallback: raw URL หากยังไม่สำเร็จหลัง retry ครบ
    return url;
  };

  loadSamples = async (version = Date.now()) => {
    this.setState({ loadingSamples: true });

    const rawUrls = [];
    for (var i = 0; i < this.state.data.sheet.examNum; i++) {
      rawUrls.push(
        process.env.REACT_APP_SHEET_URL +
          this.state.data.sheet.id +
          "/ex" +
          (i + 1).toString() +
          ".jpg?v=" +
          version.toString()
      );
    }

    const displayUrls = await Promise.all(
      rawUrls.map((url) => this.fetchSampleWithRetry(url))
    );

    const newBlobUrls = displayUrls.filter((u) => u.startsWith("blob:"));
    const oldBlobUrls = [...(this.state.blobUrls || [])];

    this.setState(
      {
        example: displayUrls,
        exampleRawUrls: rawUrls,
        blobUrls: newBlobUrls,
        sampleVersion: version,
        loadingSamples: false,
      },
      () => oldBlobUrls.forEach((u) => URL.revokeObjectURL(u))
    );
  };

  renderSamples = (displayUrls, rawUrls) => {
    if (!displayUrls || !displayUrls.length) return null;
    return displayUrls.map((displayUrl, i) => {
      const rawUrl = rawUrls?.[i] || displayUrl;
      return (
        <a key={rawUrl} href={rawUrl} target="_blank" rel="noopener noreferrer">
          <img alt="" src={displayUrl} className={style.sampleImage} />
        </a>
      );
    });
  };

  uploadCover = async (file) => {
    this.setState({ updCover: true });
    var data = await Util.sendPost("/api/moresheetStaff/uploadCoverUrl", {
      id: this.state.data.sheet.id,
    });

    var formData = new FormData();
    var keys = Object.keys(data.data.fields);
    for (var i = 0; i < keys.length; i++)
      formData.append(keys[i], data.data.fields[keys[i]]);
    formData.append("file", file);
    await Util.sendFormData(data.data.url, formData);

    this.setState({ updCover: false });
    this.reloadCover(this.state.data.sheet.id);
  };

  uploadSample = async (files) => {
    this.setState({
      updSample: ["กำลังขอคิวเพื่ออัพโหลด...", "Requesting upload queue"],
    });
    var data = await Util.sendPost("/api/moresheetStaff/uploadExamplesUrl", {
      id: this.state.data.sheet.id,
      num: files.length,
    });
    for (var j = 0; j < files.length; j++) {
      await this.setState({
        updSample:
          "กำลังอัพโหลดรูปที่ " +
          (j + 1).toString() +
          " จาก " +
          files.length.toString(),
      });
      var formData = new FormData();
      var keys = Object.keys(data.data[j].fields);
      for (var i = 0; i < keys.length; i++)
        formData.append(keys[i], data.data[j].fields[keys[i]]);
      formData.append("file", files[j]);
      await Util.sendFormData(data.data[j].url, formData);
    }
    var d = this.state.data;
    d.sheet.examNum = files.length;
    const newVersion = Date.now();
    await this.setState({ updSample: false, data: d });
    this.loadSamples(newVersion);
  };

  uploadPdf = async (file) => {
    await this.setState({ updPdf: "เริ่มต้นอัพโหลด" });
    var data = await Util.sendPost("/api/moresheetStaff/uploadPdfUrl", {
      id: this.state.data.sheet.id,
    });
    var formData = new FormData();
    var keys = Object.keys(data.data.fields);
    for (var i = 0; i < keys.length; i++)
      formData.append(keys[i], data.data.fields[keys[i]]);
    formData.append("Content-Type", "application/pdf");
    formData.append("file", file);
    //xhr
    var xhr = new XMLHttpRequest();
    xhr.open("POST", data.data.url, true);
    xhr.upload.onprogress = async (e) => {
      var percent = Math.ceil((e.loaded / e.total) * 100);
      await this.setState({
        updPdf: "อัพโหลดแล้ว " + percent.toString() + "%",
      });
    };
    xhr.onreadystatechange = async () => {
      // Call a function when the state changes.
      if (xhr.readyState === XMLHttpRequest.DONE) {
        await this.loadPdf();
        await this.setState({ updPdf: false });
      }
    };
    xhr.send(formData);
  };
  //
  loadPdf = async () => {
    var data = await Util.sendPost("/api/moresheetStaff/getSheetPdf", {
      id: this.state.data.sheet.id,
    });
    this.setState({ pdf: data.data });
  };

  isAllUndefined = (obj) => Object.values(obj).every((v) => v === undefined);

  validateUrl = (url) => {
    const reHttp = /^(https?:\/\/)([a-z0-9-]+\.)+[a-z]{2,}(:\d+)?(\/[^\s]*)?$/i;
    const urlValid = url && !url.match(reHttp);
    return urlValid;
  };

  saveDraft = async () => {
    if (this.state.saving) return;
    this.setState({ saving: true });
    var clonedObj = Object.assign({}, this.state.data.sheet);

    clonedObj.name = this.state.sCode.trim() + " " + this.state.sName.trim();

    clonedObj.sCode = this.state.sCode.trim();

    clonedObj.sName = this.state.sName.trim();

    if (clonedObj?.onlineTutor && this.isAllUndefined(clonedObj.onlineTutor)) {
      clonedObj.onlineTutor = undefined;
    }
    const urlValid = this.validateUrl(clonedObj.onlineTutor?.url);

    const liveReplayUrlValid = this.validateUrl(
      clonedObj.onlineTutor?.liveReplayUrl
    );

    if (urlValid) {
      Util.alertError("URL ของลิงค์ไลฟ์ไม่ถูกต้อง");
      this.setState({ saving: false });
      return;
    }

    if (liveReplayUrlValid) {
      Util.alertError("URL ของลิงค์ดูย้อนหลังไม่ถูกต้อง");
      this.setState({ saving: false });
      return;
    }

    var data = await Util.sendPost("/api/moresheetStaff/saveSheet", clonedObj);
    if (!data.success) Util.alertError(data.msg[0]);
    var id = window.location.search.substring(1);
    await this.reloadCover(id);
    this.setState({ saving: false });
    Util.alertSuccess("บันทึกสำเร็จ");
  };

  nl2br = (text) => {
    return text.split("\n").map((item, key) => {
      return (
        <span className={style.line} key={key}>
          {item}
        </span>
      );
    });
  };

  showSheet = async (event) => {
    await Util.sendPost("/api/moresheetStaff/shsheet", {
      id: this.state.data.sheet.id,
      visible: true,
    });
    var id = window.location.search.substring(1);
    var data = await Util.sendPost("/api/moresheetStaff/getSheet", { id });
    this.setState({ data: data.data });
  };

  hideSheet = async (event) => {
    await Util.sendPost("/api/moresheetStaff/shsheet", {
      id: this.state.data.sheet.id,
      visible: false,
    });
    var id = window.location.search.substring(1);
    var data = await Util.sendPost("/api/moresheetStaff/getSheet", { id });
    this.setState({ data: data.data });
  };

  highlightSheet = async (event) => {
    await Util.sendPost("/api/moresheetStaff/highlightsheet", {
      id: this.state.data.sheet.id,
      highlighted: true,
    });
    var id = window.location.search.substring(1);
    var data = await Util.sendPost("/api/moresheetStaff/getSheet", { id });
    this.setState({ data: data.data });
  };

  stopHighlightSheet = async (event) => {
    await Util.sendPost("/api/moresheetStaff/highlightsheet", {
      id: this.state.data.sheet.id,
      highlighted: false,
    });
    var id = window.location.search.substring(1);
    var data = await Util.sendPost("/api/moresheetStaff/getSheet", { id });
    this.setState({ data: data.data });
  };
}

export default withRouter(withAlert()(EditSheet));
